var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelescope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext3_1",
    x: 0.636719,
    width: 40,
    height: 40,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M14.2976 8.81753L14.2454 8.80609C12.6218 8.44976 10.9478 9.36137 10.3549 10.9456C9.76201 12.5298 10.4262 14.3165 11.8848 15.1137L11.9316 15.1393L19.6997 18.0465V19.25H19.1359C18.7244 19.25 18.3872 19.5879 18.3872 20C18.3872 20.3723 18.6623 20.6839 19.0187 20.7408L12.4966 29.6041C12.3125 29.8544 12.3661 30.2065 12.6163 30.3906C12.8665 30.5747 13.2186 30.5211 13.4028 30.2709L19.6997 21.7135V29.9375C19.6997 30.2482 19.9515 30.5 20.2622 30.5C20.5729 30.5 20.8247 30.2482 20.8247 29.9375V21.4587L27.3091 30.2709C27.4933 30.5211 27.8454 30.5747 28.0956 30.3906C28.3458 30.2065 28.3994 29.8544 28.2153 29.6041L21.6617 20.698C21.9393 20.5879 22.1372 20.3158 22.1372 20C22.1372 19.5879 21.8 19.25 21.3886 19.25H20.8247V18.4675L24.6252 19.8898L24.8881 19.1874L29.1025 20.7647C29.8784 21.0551 30.7428 20.6615 31.0331 19.8856L31.8218 17.7784C32.1121 17.0025 31.7186 16.1381 30.9427 15.8478L26.7282 14.2705L26.9911 13.568L14.2976 8.81753ZM25.0605 14.4471L23.7461 17.9592L16.0195 15.0675L17.3339 11.5554L25.0605 14.4471ZM28.2235 18.8341L25.4138 17.7826L26.2025 15.6753L29.0121 16.7269L28.2235 18.8341ZM14.5242 10.5039L13.2098 14.016L12.5618 13.7735C11.7941 13.3264 11.4316 12.3482 11.7597 11.4714C12.0879 10.5945 13.0036 10.0947 13.8762 10.2614L14.5242 10.5039Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelescope);
export default __webpack_public_path__ + "static/media/Telescope.e79f6ce1.svg";
export { ForwardRef as ReactComponent };